<template>
  <v-container fluid>
    <Submenu v-bind:title="'Recipe'"
      v-bind:left_buttons="submenu_left"
      v-bind:right_buttons="submenu_right"
      v-bind:showFilter="true"
      v-bind:showSearch="true"
      v-on:menu-click="menu_click"
      v-on:filter="filter_change"
      v-on:search="search_change"
      />

    <v-btn absolute fab :right="!isRtl" :left="isRtl"
    color="primary" class="mx-6 mt-n2" @click.stop="showDialog=true">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <RecipeTable v-bind:value="showDialog" v-bind:recipeId="undefined" v-on:close="close" :key="nextRecipeNo" />
    <v-layout wrap>
      <v-flex mb-4 mr-2 xs12 sm6 md4 xl2 v-for="r in recipes" v-bind:key=r.id>
        <RecipePanel  v-bind:recipeId="r.id" v-on:switch-to="switchTo" :ref="'recipe-'+r.code" />
      </v-flex>
    </v-layout>
    <v-dialog
      max-width="400px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="selectFile"
      :persistent="false"
      v-on:click:outside="cancelCSV"
      overlay-color="secondary"
    >
      <v-card class="px-3">
      <v-row>
        <v-col cols="12">
          <v-file-input
            accept=".csv,.txt"
            :label="$t('Click to select input file')"
            v-model="fileName"
          ></v-file-input>
        </v-col>
      </v-row>

       <v-card-actions>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon large color="primary" v-on="on" @click.stop="cancelCSV" class="mx-4">
              <v-icon>mdi-cancel</v-icon>
            </v-btn>
          </template>
          <span>{{$t("Cancel") + " (" + $t("exit without saving") + ")" }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon large color="primary" v-on="on" @click.stop="saveCSV" class="mx-4">
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Save") }}</span>
        </v-tooltip>
       </v-card-actions>

      </v-card>
    </v-dialog>
  </v-container>
</template>>

<script>
import RecipeTable from "../components/RecipeTable";
import RecipePanel from "../components/RecipePanel";
import Submenu from '../components/common/submenu.vue';

export default {
  data() {
    return {
      showDialog: false,
      filter: '',
      search: '',
      selectFile: false,
      fileName: null,
      submenu_left:[
        {
          index: 0,
          text: this.$i18n.t("Load From Hub"),
          icon: 'mdi-cloud-upload',
          tooltip: this.$i18n.t("Load new recipe from vFeed Hub")
        },
        {
          index: 1,
          text: this.$i18n.t("Load From CSV"),
          icon: 'mdi-file-delimited',
          tooltip: this.$i18n.t("Load new recipe from CSV file")
        }
      ],
      submenu_right:[]
    }
  },
  components: {
    "RecipeTable": RecipeTable,
    "RecipePanel": RecipePanel,
    "Submenu": Submenu
    },
  computed: {
    recipes() {
      return this.$store.getters.getRecipes(this.filter, this.search);
    },
    isRtl: function() {
      //make drawer on right for he locale
      return this.$i18n.locale == "he";
    },
    nextRecipeNo() {
      return this.$store.getters.getNextRecipeNo;
    }
  },
  methods: {
    menu_click: function(btnIndex) {
      if (btnIndex == 0)
       // Fixme:console.info(`Load from recipe Hub  ${btnIndex}`);
      if (btnIndex == 1) {
       // Fixme:console.info(`Load from recipe CSV  ${btnIndex}`);
        this.selectFile = true;
      }
    },
    cancelCSV() {
      this.fileName = null;
      this.selectFile = false;
    },
    saveCSV() {
      if (!this.fileName) {
        this.$root.$globalSnackbar(this.$i18n.t('No File Selected'), "error");
        return;
      }
      var reader = new FileReader();
      try {
        reader.readAsText(this.fileName, "utf-8" );
        reader.onload = () => {
          var text = reader.result.split("\n");
          var fields = text[1].split(",");
          fields = fields.map(s => s.trim() );
          var newRecipe = {
            code: this.$store.getters.getNextRecipeNo,
            name: fields[1],
            archive: fields[2] === 'true',
            source: fields[3],
            groupsUse: [],
            targetGroup: fields[4],  //Todo: use fields[5]
            notes: text[2].split(",")[1] || '',
            nutrition: []
          };
          for (var i=6; i<36; i++) {
            fields = text[i].split(",");
            newRecipe.nutrition.push({
              consider: (fields[0].trim() === 'true'),
              name: fields[1],
              unit: fields[2],
              min: Number(fields[3]) || 0,
              max: Number(fields[4]) || 0
            });
          }
          var payload = { id: undefined,
                        ...newRecipe,
                        translatedTargetGroup: this.$i18n.t(newRecipe.targetGroup),
                      };
          this.$store.dispatch("saveRecipe", payload);
          this.$root.$globalSnackbar(this.$i18n.t('New Recipe Created', [newRecipe.code]), "success");
        }
      } catch (error) {
       // Fixme:console.log(error);
        this.$root.$globalSnackbar(this.$i18n.t('Error loading file'), "error");
      }
      this.fileName = null;
      this.selectFile = false;
    },
    filter_change: function(event) {
      this.filter = event;
    },
    search_change: function(event) {
      this.search = event.toLowerCase();
    },
    close() {
     // Fixme:console.log("parent close clicked")
      this.showDialog=false;
    },
    switchTo(event) {
     // Fixme:console.log(this.$refs['recipe-' + event]);
      this.$nextTick( () =>
        this.$refs['recipe-' + event][0].edit() );
    }
  },
  created() {
    this.$store.dispatch("loadRecipes");
  },
  beforeDestroy() {
    // this.$store.dispatch("stopRecipeListener");
  }
}
</script>

<style>

</style>